"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

const CheckoutButtonLogo = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9446 35.7447C29.6402 35.7447 36.6893 28.6956 36.6893 20.0001C36.6893 11.3045 29.6402 4.25537 20.9446 4.25537C12.2491 4.25537 5.19995 11.3045 5.19995 20.0001C5.19995 28.6956 12.2491 35.7447 20.9446 35.7447Z",
    fill: "#E94335"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9446 35.7447C29.6402 35.7447 36.6893 28.6956 36.6893 20.0001C36.6893 11.3045 29.6402 4.25537 20.9446 4.25537C12.2491 4.25537 5.19995 11.3045 5.19995 20.0001C5.19995 28.6956 12.2491 35.7447 20.9446 35.7447Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: "5",
    y: "4",
    width: "32",
    height: "32"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9446 4.25537C29.6425 4.25537 36.6893 11.3022 36.6893 20.0001C36.6893 28.6979 29.6425 35.7447 20.9446 35.7447C12.2468 35.7447 5.19995 28.6979 5.19995 20.0001C5.19995 11.3022 12.2468 4.25537 20.9446 4.25537Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3403 23.2682C18.6637 23.2682 17.3701 21.9575 17.3701 20.281C17.3701 18.6384 18.6552 17.3022 20.3403 17.3022C21.9573 17.3022 23.2765 18.6384 23.2765 20.281C23.2765 21.9575 21.9573 23.2682 20.3403 23.2682ZM24.868 12.9618H24.3744L24.0935 14.2724C23.319 12.7235 21.0127 12.5703 19.7701 12.5703C15.8978 12.5703 12.519 16.298 12.519 21.4214C12.519 25.5405 14.9786 28.1278 18.068 28.1278C19.7956 28.1278 21.2595 27.7278 22.468 26.2895L22.1531 27.7363H22.8595H27.0212L29.2424 12.9703H24.868V12.9618Z",
    fill: "#E94335"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.4071 28.039V24.569C56.1376 25.4365 54.995 25.9655 53.4293 25.9655C50.7421 25.9655 48.4358 23.9342 48.4358 20.8873C48.4358 17.8193 50.7421 15.8304 53.4293 15.8304C54.995 15.8304 56.1376 16.2959 57.4071 17.1422V13.7145C56.2857 13.1221 54.8892 12.6354 53.0696 12.6354C48.6897 12.6354 44.9446 15.915 44.9446 20.8873C44.9446 25.8597 48.6897 29.1393 53.0696 29.1393C54.8892 29.1393 56.2645 28.6526 57.4071 28.039Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.1385 11.7891H59.7531V28.7796H63.1385V21.776C63.1385 20.5276 64.0272 19.8082 65.1697 19.8082C66.4181 19.8082 67.0317 20.4642 67.0317 21.903V28.7796H70.4171V20.9508C70.4171 18.2637 68.8091 16.7614 66.2912 16.7614C64.9582 16.7614 63.8156 17.375 63.1597 18.2002H63.1385V11.7891Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M83.8067 22.7282C83.8067 18.8138 81.3734 16.7614 78.39 16.7614C75.1316 16.7614 72.5079 19.237 72.5079 22.9609C72.5079 26.5156 74.8777 29.0758 79.0036 29.0758C80.5059 29.0758 81.8812 28.7161 83.0873 28.0179V25.2461C81.9659 25.9655 80.7175 26.4098 79.4268 26.4098C77.6495 26.4098 76.1895 25.5423 75.7452 23.8707H83.722C83.7855 23.5322 83.8067 23.1513 83.8067 22.7282ZM75.6817 21.8395C75.9991 20.3584 77.0993 19.4274 78.3689 19.4274C79.6172 19.4274 80.5694 20.3161 80.5905 21.8395H75.6817Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M88.7874 22.9186C88.7874 20.9931 90.2686 19.8082 92.0247 19.8082C93.0615 19.8082 93.9925 20.0622 94.9658 20.6969V17.5866C93.9713 16.9941 92.7018 16.7614 91.5169 16.7614C88.068 16.7614 85.3597 19.3216 85.3597 22.8974C85.3597 26.5156 88.0469 29.0758 91.5169 29.0758C92.7653 29.0758 93.9925 28.7796 94.9658 28.2718V25.1614C93.9925 25.8597 92.9557 26.0289 92.0247 26.0289C90.2686 26.0289 88.7874 24.8652 88.7874 22.9186Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M120.188 29.0758C123.679 29.0758 126.345 26.5367 126.345 22.9186C126.345 19.2581 123.679 16.7613 120.188 16.7613C116.739 16.7613 114.031 19.2581 114.031 22.9186C114.031 26.5579 116.739 29.0758 120.188 29.0758ZM120.188 26.0289C118.792 26.0289 117.459 24.9075 117.459 22.9186C117.459 20.9296 118.792 19.8082 120.188 19.8082C121.585 19.8082 122.939 20.9296 122.939 22.9186C122.939 24.8863 121.585 26.0289 120.188 26.0289Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M133.694 29.0758C137.037 29.0758 139.068 26.981 139.068 24.0188V17.0576H135.683V23.9977C135.683 25.3307 134.942 26.0289 133.694 26.0289C132.467 26.0289 131.768 25.3307 131.768 24.0188V17.0576H128.383V24.0188C128.383 26.981 130.372 29.0758 133.694 29.0758Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M145.713 14.3492H142.454V17.0576H140.783V19.8505H142.433V24.2727C142.433 27.1926 144.104 29.0335 147.215 29.0335C148.04 29.0335 148.569 28.9488 149.056 28.843V26.0077C148.675 26.0712 148.315 26.1135 147.998 26.1135C146.686 26.1135 145.713 25.5422 145.713 24.0611V19.8505H148.844V17.0576H145.713V14.3492Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M111.638 28.7008L101.138 20.2208L111.638 11.7308V28.7008Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M111.638 24.2108L106.698 20.2208L111.638 16.2208V24.2108Z",
    fill: "#E94335"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M100.838 28.1208H97.3984V10.8608H100.838V28.1208Z",
    fill: "white"
  }));
};
var _default = exports.default = CheckoutButtonLogo;